import { useSettingsContext } from "../../../hook/useSettingsContext";

export default function QuantityAlert() {
    const { quantity, getOption, showMinAlert, showMaxAlert } =
        useSettingsContext();
    const minMessage = getOption("minMessage", "messages");
    const maxMessage = getOption("maxMessage", "messages");

    if (!showMinAlert && !showMaxAlert) {
        return null;
    }

    return (
        <div className="quantity-alert">
            {showMinAlert && minMessage && (
                <div className="alert alert-error">{minMessage}</div>
            )}
            {showMaxAlert && maxMessage && (
                <div className="alert alert-error">{maxMessage}</div>
            )}
        </div>
    );
}
